import { Config } from 'types/config';

const config: Config = {
  app: {
    head: {
      defaultTitle: 'Mymoria Vollmacht',
    },
  },
  dateFormat: {
    view: 'DD.MM.YYYY',
    /* what is x ?*/
    timeStamp: 'x',
  },
  api: {
    endpoint: process.env.REACT_APP_GATEWAY,
  },
};

export default config;
